import styled from "styled-components";
import { Link as ScrollLink, animateScroll as scroll } from 'react-scroll';
import { useTranslation } from 'react-i18next';
import i18n from '../i18n';
import { css } from 'styled-components';
import { motion, scale } from "framer-motion";
import { useState, useRef } from "react";

export default function Header() {
  const { t } = useTranslation();

  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language === 'es' ? 'en' : 'es');
  };

  const [isOpen, setIsOpen] = useState(false);
  const navRef = useRef<HTMLDivElement>(null);

  return (
    <HeaderWrapper>
      <Title onClick={() => scroll.scrollToTop()}>RedDigitalCreations</Title>
      <NavPc>
        <NavLink to="inicio" smooth duration={500}>{t('header.Inicio')}</NavLink>
        <NavLink to="servicios" smooth duration={500}>{t('header.Servicios')}</NavLink>
        <NavLink to="portafolio" smooth duration={500}>{t('header.Portafolio')}</NavLink>
        <NavLink to="contacto" smooth duration={500}>{t('header.Contacto')}</NavLink>
          <LangButton onClick={toggleLanguage}>
            {i18n.language === 'es' ? 'EN' : 'ES'}
          </LangButton>
      </NavPc>
      <NavMobile>
        <motion.div style={{width:"170px", display:'flex', justifyContent:'center'}} whileTap={{scale: 0.7}}><NavLink mobileNavLink to="inicio" smooth duration={500}>{t('header.Inicio')}</NavLink> </motion.div> 
        <motion.div style={{width:"170px", display:'flex', justifyContent:'center'}} whileTap={{scale: 0.7}}><NavLink mobileNavLink to="servicios" smooth duration={500}>{t('header.Servicios')}</NavLink></motion.div>
        <motion.div style={{width:"170px", display:'flex', justifyContent:'center'}} whileTap={{scale: 0.7}}><NavLink mobileNavLink to="portafolio" smooth duration={500}>{t('header.Portafolio')}</NavLink></motion.div>
        <motion.div style={{width:"170px", display:'flex', justifyContent:'center'}} whileTap={{scale: 0.7}}><NavLink mobileNavLink to="contacto" smooth duration={500}>{t('header.Contacto')}</NavLink></motion.div>
        
        

          <LangButton type="button" onClick={toggleLanguage}>
            {i18n.language === 'es' ? 'EN' : 'ES'}
          </LangButton>
      </NavMobile>
    </HeaderWrapper>
  );
}


const HeaderWrapper = styled.header`
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 50;
  background-color: #0D0D0D;
  box-shadow: 0 2px 4px hsla(0, 0.00%, 0.00%, 0.30);
  padding: 1rem 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;

  a {
    color: #ffffff;
    min-width: 60px;
    text-align: center;
  }
`;

const Title = styled.h1`
  font-size: 1.25rem;
  font-weight: bold;
  color: #FF4C4C;
  cursor: pointer;
`;

const NavPc = styled.nav`
  display: none;
  @media(min-width: 768px) {
    display: flex;
    align-items: center;
    gap: 16px;
  }
  
`;
const NavMobile = styled.nav`
  display: flex;
  flex-direction: column;
  position: fixed;
  align-items: center;
  justify-content: space-evenly;
  gap: 16px;
  background-color: #0009;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  top: 0;
  left: 0;
  right: 0;
  height: 100vh;
  transform: translateX(100%);
  @media(min-width: 768px) {
    display: none;
  }
`;

const NavLink = styled(ScrollLink)`
  text-align: center;
  @media (min-width: 1024px) {
    cursor: pointer;

    &:hover {
      text-decoration: underline;
    }
  }

  ${props => props.mobileNavLink && css`
        background-color: #000;
        color: #fff;
        padding: 20px;
        border: 2px solid red;
        width: 160px;
        border-radius: 15px;
    `}
`;

const LangButton = styled.button`
  margin-left: 1rem;
  padding: 0.25rem 0.75rem;
  height: 30px;
  width: 100px;
  font-size: 0.875rem;
  background-color: #E63946;
  color: white;
  border-radius: 10px;
  transition: background-color 0.3s, transform .3s;
  border: none;
  &:active {
    background-color: #FF4C4C;
    transform: scale(.8);
  }
  @media(max-width: 768px) {
    min-width: 160px;
    padding: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;
